<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
/**
 * Style order:
 * 1- Bootstrap
 * 2- Bootstrap-vue
 * 3- Shared
 * 4- Platform
 */
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import '@root_shared/scss/style.scss';
import '@root_platform/scss/style.scss';

export default {
  name: 'App',
};
</script>

<style lang="scss">
</style>
